import { DateTime } from 'luxon'

import { LocationResponseDTO } from '@core/api/dtos/response/location/location'
import { Location } from '@core/api/entities/location'

import { GooglePlaceDataMapper } from './googlePlaceDataMapper'
import { ZoneMapper } from './zone/zoneMapper'

export class LocationMapper {
	static toEntity = (dto: LocationResponseDTO): Location => {
		const zones =
			dto.players?.data.map((player) => ZoneMapper.toEntity(player)) ?? []

		const location = Location.create({
			id: dto.id,
			uuid: dto.uuid,
			accountId: dto.account_id,
			accountName: dto.account?.data?.name,
			name: dto.name,
			country: dto.country,
			address: dto.address,
			phoneNumber: dto.phone_number,
			email: dto.email,
			manager: dto.manager,
			createdAt: DateTime.fromISO(dto.created_at),
			timezone: dto.timezone,
			type: dto.type,
			city: dto.city,
			zipCode: dto.zip_code,
			additionalInformation: dto.additional_information,
			idType: dto.id_type,
			idNumber: dto.id_number,
			lastSmartUpdateAt: dto.last_smart_update_at
				? DateTime.fromISO(dto.last_smart_update_at)
				: null,
			googlePlaceData: dto.lastGooglePlaceData
				? GooglePlaceDataMapper.toEntity(dto.lastGooglePlaceData.data)
				: null,
			hasVolumeControl: dto.has_volume_control,
			zones: [],
		})

		zones.forEach((zone) => {
			zone.location = location
		})
		location.zones = zones

		return location
	}

	static toEntities = (dtos: LocationResponseDTO[]): Location[] => {
		return dtos.map(this.toEntity)
	}
}
